import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { AuditEventNamesData } from "@/hooks/queries/admin-audit-types";

// GET /admin/audit/event-names (Story 11.7, AC5) — the event-name vocabulary that
// feeds the console's Event filter. Read from the store rather than a hardcoded
// catalog, so the dropdown can never offer a value that matches nothing.

/** Root key for the event-name catalog. */
export const AUDIT_EVENT_NAMES_QUERY_KEY = "admin-audit-event-names";

export function useAuditEventNames() {
  return useQuery({
    queryKey: [AUDIT_EVENT_NAMES_QUERY_KEY] as const,
    queryFn: () => apiFetch<AuditEventNamesData>("/admin/audit/event-names"),
  });
}
